import { styled } from '@mui/material';

export const noImageDivStyle = {
    height: '400px',
    width: 500,
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    border: '1px solid black',
    marginBottom: 8,
}

export const selectedImageStyle = {
    height: '400px',
    marginBottom: '8px',
    marginTop: '8px',
};

export const VisuallyHiddenInput = styled('input')({
    clip: 'rect(0 0 0 0)',
    clipPath: 'inset(50%)',
    height: 1,
    overflow: 'hidden',
    position: 'absolute',
    bottom: 0,
    left: 0,
    whiteSpace: 'nowrap',
    width: 1,
});

export const adminPageRootStyle = {
    with: '100%',
    minHeight: '100%',
    display: 'flex',
    flexDirection: 'column',

    h2: {
        alignSelf: 'center',
    }
}

export const formStyle = {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
};